import { isNode } from './isNode';
export const createEnvGetter = (key, options = {
    suffixAble: true,
}) => {
    const getValue = () => {
        var _a, _b, _c;
        if (isNode()) {
            const serverEnv = (_a = process.env) === null || _a === void 0 ? void 0 : _a[`SERVER_${key}`];
            return (serverEnv || ((_b = process.env) === null || _b === void 0 ? void 0 : _b[key]));
        }
        return (_c = globalThis.__fw_env__) === null || _c === void 0 ? void 0 : _c[key];
    };
    if (options.suffixAble) {
        return (suffix) => {
            const value = getValue();
            if (!value) {
                throw new Error(`Missing variable [${key}]`);
            }
            if (suffix) {
                return `${value}/${suffix}`;
            }
            return value;
        };
    }
    return () => {
        const value = getValue();
        if (!value) {
            throw new Error(`Missing variable [${key}]`);
        }
        return value;
    };
};
